import './login-checkbox.scss'
import LoginComponent from '../login-component';

export default class LoginCheckbox extends LoginComponent {

    constructor(props) {
        super(props);
    }

    render () {
        const className = `login-checkbox ${this.props.error? 'error': ''}`;

        return (
            <div className={className}>
                <label className="checkbox" onClick={this.props.onChange}>
                    <div className="checkbox-svg-placeholder" data-gaeventcategory={this.props.gaEventCategory} data-gaeventaction={this.props.gaEventAction}>
                        {this.props.checked
                            ? <svg className="checkbox-svg checked" viewBox="0 0 20 20"><path d="M16.01,0H3.99C1.79,0,0,1.99,0,4.43v11.14C0,18.01,1.79,20,3.99,20h12.03c2.19,0,3.99-1.99,3.99-4.43V4.43 C20,1.99,18.21,0,16.01,0z M17.01,6.61l-8.9,8.9c-0.01,0.01-0.02,0.01-0.04,0.02C8.03,15.57,8,15.61,7.95,15.65 c-0.07,0.05-0.15,0.08-0.23,0.12c-0.05,0.03-0.1,0.06-0.15,0.08c-0.17,0.06-0.34,0.1-0.52,0.1c-0.17,0-0.35-0.04-0.51-0.1 c-0.03-0.01-0.06-0.02-0.08-0.03c-0.16-0.07-0.3-0.16-0.43-0.28C6.02,15.53,6,15.52,5.99,15.51c-0.01-0.01-0.02-0.04-0.03-0.05 c-0.03-0.04-0.07-0.07-0.11-0.11l-3-4c-0.5-0.66-0.36-1.6,0.3-2.1c0.66-0.5,1.6-0.36,2.1,0.3l1.96,2.62l7.68-7.68 c0.59-0.58,1.54-0.59,2.12,0C17.6,5.07,17.6,6.02,17.01,6.61z"/></svg>
                            : <svg className="checkbox-svg" viewBox="0 0 20 20"><path d="M16,20H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h12c2.2,0,4,1.8,4,4v12C20,18.2,18.2,20,16,20z M18,16V4 c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v12c0,1.1,0.9,2,2,2h12C17.1,18,18,17.1,18,16z"/></svg>
                        }
                    </div>
                    <span dangerouslySetInnerHTML={{__html: this.props.label }} data-gaeventcategory={this.props.gaEventCategory} data-gaeventaction={this.props.gaEventAction}
                          title={this.props.title ? this.props.title : ''}/>
                </label>
                {this.props.error
                    ? <span className="checkbox-error" dangerouslySetInnerHTML={{__html: this.props.error}} />
                    : null
                }
            </div>
        )
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/ui-elements/login-checkbox.jsx
 **/